
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guides/enhance/dashboard",
      function () {
        return require("private-next-pages/guides/enhance/dashboard/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guides/enhance/dashboard"])
      });
    }
  